import React from 'react';

import { AI_PASTE_MENU_SECTION } from '@atlaskit/editor-common/toolbar';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterComponent } from '@atlaskit/editor-ui-control-model';

import { makeOpenRemixModal, PASTE_MENU_SOURCE } from '../../editor-commands/open-remix-modal';
import type { MalleableUiPlugin } from '../../malleableUiPluginType';

import { REMIX_PASTE_MENU_KEY } from './paste-menu-constants';
import { RemixPasteMenuItem } from './PasteMenuRemixButton';

type GetPasteMenuItemsParams = {
	api: ExtractInjectionAPI<MalleableUiPlugin>;
};

export const getPasteMenuItems = ({ api }: GetPasteMenuItemsParams): RegisterComponent[] => {
	const rules = api.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
	if (!rules) {
		return [];
	}

	const {
		allRules,
		containsTableRule,
		excludedAncestorRule,
		hideIfSingleNodeRule,
		isSingleLinkRule,
		minCharsRule,
		notProseRule,
	} = rules;

	const disabled = excludedAncestorRule(['codeBlock', 'heading']);
	const AI_PASTE_MENU_SECTION_KEY = AI_PASTE_MENU_SECTION.key;

	return [
		{
			type: 'menu-item',
			key: REMIX_PASTE_MENU_KEY,
			parents: [
				{
					type: 'menu-section',
					key: AI_PASTE_MENU_SECTION_KEY,
					// Rank 6 — shown after Make Longer (rank 5).
					rank: 6,
				},
			],
			isHidden: allRules(
				minCharsRule(100),
				hideIfSingleNodeRule,
				isSingleLinkRule,
				disabled,
				notProseRule,
				containsTableRule,
			),
			component: () => (
				<RemixPasteMenuItem
					onClick={() => {
						api?.core?.actions.execute(
							makeOpenRemixModal(api)({
								metadata: { interactionSource: 'remixModalFromPasteMenu' },
								source: PASTE_MENU_SOURCE,
							}),
						);
					}}
				/>
			),
		},
	];
};
